import Model from './model';

export default Model.extend( {

    endpoint: 'priorities?apiVersion=2.0',
    
    defaults: {
        name: '',
        cluster: null,
        icon: 'default_category.png'
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/model/priority.js